import appConfig from 'app-config';
import {getImageSrc} from './lobIconUtil';

export function getBrokerUtilLogo(accountPolicyData) {
    if(!(_.isEmpty(accountPolicyData) && accountPolicyData !== null)){

        var brokerImgPathData = {
        "org1": {
           imagePath: "branding/broker/Advantage Insurance Brokers.png"
         },
         "org2": {
             imagePath: "branding/broker/dbi Brokers Ltd.png"
           },
         "org3": {
            imagePath: "branding/broker/E Bollenbach Insurance Brokers.png"
          },
          "org4": {
            imagePath: "branding/broker/Elmira Insurance Brokers Ltd.png"
          },
          "org5": {
            imagePath: "branding/broker/Henderson Yost Insurance.png"
          },
          "org6": {
            imagePath: "branding/broker/Ives Insurance Brokers Ltd.png"
          },
          "org7": {
            imagePath: "branding/broker/Josslin Insurance.png"
          },
          "org8": {
            imagePath: "branding/broker/Morrison Insurance.png"
          },
          "org9": {
            imagePath: "branding/broker/Pirie & Burgess Insurance Brokers Inc.png"
          },
          "org10": {
            imagePath: "branding/broker/Robert J Morris Insurance & Consulting Ltd.png"
          },
          "org11": {
            imagePath: "branding/broker/Van Allen Insurance Inc.png"
          },
         }

         const orgList = {
             'org1' : ['94'],
             'org2' : ['20','21','22','23'],
             'org3' : [''],
             'org4' : ['78'],
             'org5' : ['93'],
             'org6' : ['09'],
             'org7' : ['43'],
             'org8' : [''],
             'org9' : ['44'],
             'org10' : ['92'],
             'org11' : ['95' , '96']
             
         }
         var producerCode = accountPolicyData[0].producerContact.producerCode_EY;
         const getDataByProducerCode = (producerCode) => {
           var orgNames = Object.keys(orgList);
           //  console.log(orgNames)
           return _.filter(orgNames, (orgName) => {
            //console.log(orgList[orgName]);
            return orgList[orgName].indexOf(producerCode) != -1
          })
         }
        
         const srcPath = brokerImgPathData[getDataByProducerCode(producerCode)] ? brokerImgPathData[getDataByProducerCode(producerCode)].imagePath : undefined;
         if(!(_.isUndefined(srcPath))){
            return getImageSrc(srcPath);
         }else{
            return false;
            }
        }
}


